export const CHECK_LOGGED_IN_REQUEST = 'CHECK_LOGGED_IN_REQUEST';
export const CHECK_LOGGED_IN_SUCCESS = 'CHECK_LOGGED_IN_SUCCESS';
export const CHECK_LOGGED_IN_FAILURE = 'CHECK_LOGGED_IN_FAILURE';